import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersist from 'vuex-persist'

// for global field getters and setters for two way data binding
import { getField, updateField } from 'vuex-map-fields'

// import modules
import blackouts from './modules/blackouts'
import cart from './modules/cart'
import facilities from './modules/facilities'
import invoices from './modules/invoices'
import itineraries from './modules/itineraries'
import info from './modules/info'
import parkingBookings from './modules/parkingBookings'
import passes from './modules/passes'
import settings from './modules/settings'
import person from './modules/person'
import vehicles from './modules/vehicles'
import reports from './modules/reports'
import otherCharges from './modules/otherCharges'
import commercialPermits from './modules/commercialPermits'

// import initial states
import blackoutsState from './modules/blackouts/state'
import cartState from './modules/cart/state'
import facilitiesState from './modules/facilities/state'
import invoicesState from './modules/invoices/state'
import itinerariesState from './modules/itineraries/state'
import infoState from './modules/info/state'
import parkingBookingsState from './modules/parkingBookings/state'
import passesState from './modules/passes/state'
import settingsState from './modules/settings/state'
import personState from './modules/person/state'
import vehiclesState from './modules/vehicles/state'
import reportsState from './modules/reports/state'
import otherChargesState from './modules/otherCharges/state'
import commercialPermitsState from './modules/commercialPermits/state'

Vue.use(Vuex)

// initial state
let initialState = {
  blackouts: blackoutsState,
  cart: cartState,
  facilities: facilitiesState,
  info: infoState,
  invoices: invoicesState,
  itineraries: itinerariesState,
  parkingBookings: parkingBookingsState,
  passes: passesState,
  reports: reportsState,
  settings: settingsState,
  vehicles: vehiclesState,
  otherCharges: otherChargesState,
  person: personState,
  commercialPermits: commercialPermitsState
}
// initial state
let initialReservationState = {
  cart: cartState,
  info: infoState,
  invoices: invoicesState,
  itineraries: itinerariesState,
  parkingBookings: parkingBookingsState,
  passes: passesState,
  vehicles: vehiclesState,
  otherCharges: otherChargesState
}

const vuexLocalStorage = new VuexPersist({
  key: 'vuex', // The key to store the state on in the storage provider.
  storage: window.localStorage, // or window.sessionStorage or localForage
  reducer: state => ({ // Function that passes the state and returns the state with only the objects you want to store.
    person: state.person
  })
  // Function that passes a mutation and lets you decide if it should update the state in localStorage.
  // filter: mutation => (true)
})

export default new Vuex.Store({
  modules: {
    blackouts,
    cart,
    facilities,
    invoices,
    itineraries,
    info,
    parkingBookings,
    passes,
    settings,
    person,
    vehicles,
    reports,
    otherCharges,
    commercialPermits
  },
  getters: {
    getField
  },
  mutations: {
    updateField,
    clearData (state, payload) {
      Object.keys(initialReservationState).forEach(key => {
        Object.assign(state[key], initialReservationState[key]())
      })
    },
    logout (state, payload) {
      Object.keys(initialState).forEach(key => {
        Object.assign(state[key], initialState[key]())
      })
    }
  },
  plugins: [vuexLocalStorage.plugin]
})
